const text = {
  small: {
    normal: 'normal normal normal 12px Quicksand',
    bold: 'normal normal bold 12px Quicksand',
  },
  medium: {
    normal: 'normal normal normal 14px Quicksand',
    bold: 'normal normal bold 14px Quicksand',
  },
  title: {
    normal: 'normal normal normal 16px Quicksand',
    bold: 'normal normal bold 16px Quicksand',
  },
  subtitle: {
    normal: 'normal normal normal 13px Quicksand',
    bold: 'normal normal bold 13px Quicksand',
  },
  big: {
    normal: 'normal normal normal 30px Quicksand',
    bold: 'normal normal bold 30px Quicksand',
  },
};

export default text;
